import React, { useEffect, useState } from "react";
import axios from "axios";
import { Bell, Send, RefreshCw } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const card = { border: "1px solid #e5e7eb", borderRadius: 12, padding: 18, background: "white" };
const label = { fontFamily: "Manrope", fontSize: 11, fontWeight: 700, letterSpacing: "0.05em",
  textTransform: "uppercase", color: "#6b7280", marginBottom: 4 };
const input = { width: "100%", boxSizing: "border-box", border: "1px solid #e5e7eb",
  borderRadius: 8, padding: "9px 11px", fontFamily: "Manrope", fontSize: 13 };
const btn = { display: "inline-flex", alignItems: "center", gap: 6, background: "#111827",
  color: "white", border: "none", borderRadius: 8, padding: "9px 16px",
  fontFamily: "Manrope", fontSize: 12.5, cursor: "pointer" };
const ghost = { ...btn, background: "white", color: "#374151", border: "1px solid #e5e7eb" };

const DEFAULT_TITLE = "ANGIOLINI VIP CLUB 🤎";
const DEFAULT_BODY = "Новые коллекции Италии уже в ANGIOLINI! Откройте приложение и познакомьтесь с новинками. 🇮🇹";

/** Диагностика push и адресная тестовая отправка (только супер-админ). */
export default function AdminPushTest() {
  const [status, setStatus] = useState(null);
  const [phones, setPhones] = useState("");
  const [title, setTitle] = useState(DEFAULT_TITLE);
  const [body, setBody] = useState(DEFAULT_BODY);
  const [report, setReport] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const load = async () => {
    setError("");
    try {
      const r = await axios.get(`${API}/admin/notifications/push-status`, { withCredentials: true });
      setStatus(r.data);
    } catch (e) {
      setError(e.response?.data?.detail || "Не удалось получить статус");
    }
  };
  useEffect(() => { load(); }, []);

  const send = async () => {
    const list = phones.split(/[\n,;]+/).map(p => p.trim()).filter(Boolean);
    if (!list.length) { setError("Укажите номера устройств"); return; }
    if (!window.confirm(`Отправить тестовый push на ${list.length} номер(ов)? Остальным клиентам ничего не уйдёт.`)) return;
    setBusy(true); setError(""); setReport(null);
    try {
      const r = await axios.post(`${API}/admin/notifications/send-test`,
        { phones: list, title, body }, { withCredentials: true });
      setReport(r.data);
      load();
    } catch (e) {
      setError(e.response?.data?.detail || "Не удалось отправить");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-push-test" style={{ paddingBottom: 40 }}>
      <h2 style={{ fontFamily: "Cormorant Garamond", fontSize: 30, fontWeight: 400, margin: 0 }}>
        Push-уведомления · проверка
      </h2>
      <div style={{ fontFamily: "Manrope", fontSize: 12.5, color: "#6b7280", margin: "6px 0 18px" }}>
        Адресная отправка на конкретные устройства. Массовые рассылки клиентам отсюда невозможны.
      </div>

      <div style={{ display: "grid", gap: 16, gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))" }}>
        <div style={card}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ fontFamily: "Manrope", fontSize: 13, fontWeight: 700, color: "#111827" }}>
              <Bell size={13} style={{ verticalAlign: -2, marginRight: 6 }} /> Подписанные устройства
            </div>
            <button onClick={load} style={ghost} data-testid="push-status-refresh">
              <RefreshCw size={12} /> Обновить
            </button>
          </div>
          {status ? (
            <div data-testid="push-status-body" style={{ fontFamily: "Manrope", fontSize: 13, lineHeight: 1.8, marginTop: 10 }}>
              <div>Firebase на сервере: <b style={{ color: status.fcm_ready ? "#15803d" : "#dc2626" }}>
                {status.fcm_ready ? "подключён" : "не настроен"}</b></div>
              <div>Клиентов с push-токенами: <b>{status.users_with_tokens}</b></div>
              <div>Подписаны на уведомления: <b data-testid="consent-count">{status.consent_users}</b></div>
              <div style={{ color: "#6b7280" }}>· из них с живыми токенами: {status.consent_reachable}</div>
              {Object.entries(status.by_platform || {}).map(([p, v]) => (
                <div key={p} style={{ color: "#6b7280" }}>· {p}: {v.users} клиент(ов), токенов {v.tokens}</div>
              ))}
              {(status.recent || []).length > 0 && (
                <div style={{ marginTop: 8 }}>
                  <div style={label}>Последние подписки</div>
                  {status.recent.map((r, i) => (
                    <div key={i} style={{ color: "#374151", fontSize: 12.5 }}>
                      {r.phone} · {r.platform || "?"} · {new Date(r.registered_at).toLocaleString("ru-RU")}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : <div style={{ fontFamily: "Manrope", fontSize: 12.5, color: "#9ca3af", marginTop: 10 }}>Загрузка…</div>}
        </div>

        <div style={card}>
          <div style={{ fontFamily: "Manrope", fontSize: 13, fontWeight: 700, color: "#111827", marginBottom: 10 }}>
            Тестовая отправка
          </div>
          <div style={label}>Номера устройств (по одному в строке, до 5)</div>
          <textarea rows={3} value={phones} onChange={e => setPhones(e.target.value)}
            data-testid="push-test-phones" placeholder={"+7 701 801 77 55"} style={{ ...input, resize: "vertical" }} />
          <div style={{ ...label, marginTop: 12 }}>Заголовок</div>
          <input value={title} onChange={e => setTitle(e.target.value)}
            data-testid="push-test-title" style={input} />
          <div style={{ ...label, marginTop: 12 }}>Сообщение</div>
          <textarea rows={3} value={body} onChange={e => setBody(e.target.value)}
            data-testid="push-test-body" style={{ ...input, resize: "vertical" }} />
          <div style={{ marginTop: 10, fontFamily: "Manrope", fontSize: 11, color: "#6b7280" }}>
            Push уходит только клиентам с активной подпиской на уведомления.
          </div>
          <button onClick={send} disabled={busy} data-testid="push-test-send" style={{ ...btn, marginTop: 14 }}>
            <Send size={13} /> {busy ? "Отправляем…" : "Отправить на мои устройства"}
          </button>
          {error && <div data-testid="push-test-error" style={{ color: "#dc2626", fontFamily: "Manrope", fontSize: 12.5, marginTop: 10 }}>{error}</div>}
          {report && (
            <div data-testid="push-test-report" style={{ fontFamily: "Manrope", fontSize: 12.5, marginTop: 12, lineHeight: 1.7 }}>
              {report.report.map((r, i) => (
                <div key={i} style={{ color: r.accepted_by_firebase ? "#15803d" : "#b45309" }}>
                  {r.phone} {r.name ? `· ${r.name}` : ""} — {r.status}
                  {r.tokens ? ` (устройств: ${r.tokens}${r.accepted_by_firebase ? `, принято: ${r.accepted_by_firebase}` : ""})` : ""}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
